export default "__VITE_ASSET__ecbc5356__$_?nuxt_component=async__"